import React, { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';
import { gallery } from '../data/mock';
import { Dialog, DialogContent } from './ui/dialog';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="gallery" className="py-16 sm:py-24 bg-gradient-to-b from-[#0d1f35] to-[#0a1628]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-[#c9a961] text-xs sm:text-sm font-semibold tracking-widest uppercase">Visual Tour</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-2 sm:mt-3 mb-4 sm:mb-6">Project Gallery</h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-transparent via-[#c9a961] to-transparent mx-auto" />
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
          {gallery.map((item, index) => (
            <div
              key={index}
              onClick={() => setSelectedImage(item)}
              className="group relative cursor-pointer rounded-xl sm:rounded-2xl overflow-hidden shadow-lg shadow-black/30 hover:shadow-2xl hover:shadow-[#c9a961]/20 transition-all duration-500"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/90 via-[#0a1628]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-6">
                  <p className="text-white font-medium text-sm sm:text-base mb-1 sm:mb-2">{item.alt}</p>
                  <div className="flex items-center gap-2 text-[#c9a961]">
                    <ZoomIn className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span className="text-xs sm:text-sm">View</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-5xl bg-[#0a1628]/95 backdrop-blur-xl border-white/10 p-0">
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 z-10 p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
          >
            <X className="w-5 h-5 text-white" />
          </button>
          {selectedImage && (
            <img src={selectedImage.src} alt={selectedImage.alt} className="w-full h-auto rounded-lg" />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default GallerySection;
